//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const GetMessageSubject = createAsyncThunk(
  "GetMessageSubject",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingGetMessageSubject(""));
      const response = await UsePortalApi(
        `Patient/GetMessageSubject`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response, "response");
        dispatch(gettingGetMessageSubjectSuccess(response[0].entry));
      } else {
        dispatch(gettingGetMessageSubjectFailed(response?.errorMessage));
      }
    } catch (error) {
      dispatch(gettingGetMessageSubjectFailed(error));
    }
  }
);
const GetMessageSubjectSlice = createSlice({
    name: "GetMessageSubject",
    initialState: {
      GetMessageSubjectData: null,
      isGetMessageSubject: false,
      errorGetMessageSubject: false,
    },
    reducers: {
      gettingGetMessageSubject: (state, action) => {
        state.GetMessageSubjectData = null;
        state.isGetMessageSubject = true;
        state.errorGetMessageSubject = false;
      },
      gettingGetMessageSubjectSuccess: (state, action) => {
        state.GetMessageSubjectData = action.payload;
        state.isGetMessageSubject = false;
        state.errorGetMessageSubject = false;
      },
      gettingGetMessageSubjectFailed: (state, action) => {
        state.GetMessageSubjectData = null;
        state.isGetMessageSubject = false;
        state.errorGetMessageSubject = true;
      },
      gettingGetMessageSubjectClear: (state, action) => {
        state.GetMessageSubjectData = null;
        state.isGetMessageSubject = false;
        state.errorGetMessageSubject = false;
      },
    },
});
export const {
  gettingGetMessageSubject,
  gettingGetMessageSubjectSuccess,
  gettingGetMessageSubjectFailed,
  gettingGetMessageSubjectClear,
} = GetMessageSubjectSlice.actions;
export default GetMessageSubjectSlice.reducer;
